import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    title: {
      textAlign: "left",
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 500,
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    margin: {
      marginTop: 80,
    },
    divider: {
      marginBottom: 10,
    },
  }),
  { name: "SectionHeader" },
);
